import { z } from 'zod';
import { purchaseOrderItemUnitCostSchema } from './item-input.js';
export const correctPurchaseOrderItemCostInputSchema = z.object({
    unitCost: purchaseOrderItemUnitCostSchema,
});
//# sourceMappingURL=correct-item-cost-input.js.map